export { default } from './ModuleToolbar';
